import { useProperty } from '@eti/providers';
import { useEffect } from 'react';
import type { BrandedFare } from '@eti/schema-types';
import { useToggle } from '../../../../../../common/custom-hooks/toggle';

const useBrandedFareOptions = (
  brandedFares: BrandedFare[],
  selectedBrandedFareSelectionKey: string,
  isMediumScreenWidth: boolean,
) => {
  const { p } = useProperty();
  const numberOfBrandedFaresToShow = isMediumScreenWidth ? 2 : 3;
  const isContentToggleable = brandedFares.length > numberOfBrandedFaresToShow;
  const alwaysVisibleOptions = brandedFares.slice(0, numberOfBrandedFaresToShow);
  const toggleableOptions = isContentToggleable
    ? brandedFares.slice(numberOfBrandedFaresToShow)
    : null;

  const isSelectedBrandedFareAmongToggleableOptions = toggleableOptions?.some(
    (toggleableOption) => toggleableOption.selectionKey === selectedBrandedFareSelectionKey,
  );

  const isShowMoreDefaultOpen = p('BrandedFares.ShowMore.DefaultOpen');
  const { isOpen, handleToggle } = useToggle(
    isContentToggleable && (isShowMoreDefaultOpen || isSelectedBrandedFareAmongToggleableOptions),
  );

  useEffect(() => {
    sessionStorage.setItem('brandedFareOffered', 'true');
  }, []);

  return { alwaysVisibleOptions, handleToggle, isContentToggleable, isOpen, toggleableOptions };
};

export default useBrandedFareOptions;
